const $ = jQuery;
import wcbtPrice from '../product-filter/price';
import wcbtSearch from '../product-filter/search';
import wcbtProductFilterField from '../product-filter/field';
const wcbtElementorHook = () => {
	$( document ).ready( function() {
		$( window ).on( 'elementor/frontend/init', () => {
			elementorFrontend.hooks.addAction( 'frontend/element_ready/wcbt-filterproduct.default',wcbtProductFilterField );
		});
	}
	);
};

export default wcbtElementorHook;
